import * as React from 'react';
import { useSelector } from 'react-redux';

import { PostRssFeedLink } from '../../components/PostRssFeedLink';
import { selectPost } from '../../selectors/post';
import { EType } from '../../repositories/journal/entities/journal/JournalAttributesSchema';

/**
 * Контейнер со ссылкой на rss-фид
 */
export const PostRssFeedLinkContainer = () => {
  const post = useSelector(selectPost);

  if (!('id' in post)) {
    return null;
  }

  const {
    attributes: { type },
  } = post;

  if (type !== EType.News) {
    return null;
  }

  return <PostRssFeedLink />;
};
